export function eur(v) {
  const n = Number(v || 0);
  return new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(n);
}

export function eur2(v) {
  const n = Number(v || 0);
  return new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR", minimumFractionDigits: 2 }).format(n);
}

export function pct(v) {
  const n = Number(v || 0);
  return `${n.toLocaleString("it-IT", { maximumFractionDigits: 1 })}%`;
}

export function dateIt(iso) {
  if (!iso) return "-";
  try {
    const d = new Date(String(iso).length <= 10 ? `${iso}T00:00:00` : iso);
    if (isNaN(d)) return String(iso);
    return new Intl.DateTimeFormat("it-IT", { day: "2-digit", month: "2-digit", year: "numeric", timeZone: "Europe/Rome" }).format(d);
  } catch {
    return String(iso);
  }
}

export function dateTimeIt(iso) {
  if (!iso) return "-";
  try {
    const d = new Date(iso);
    if (isNaN(d)) return String(iso);
    return new Intl.DateTimeFormat("it-IT", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit", timeZone: "Europe/Rome" }).format(d);
  } catch {
    return String(iso);
  }
}

export function todayIso() {
  return new Date().toISOString().slice(0, 10);
}

export function isOverdue(iso) {
  if (!iso) return false;
  try {
    return new Date(`${String(iso).slice(0, 10)}T23:59:59`) < new Date();
  } catch {
    return false;
  }
}
